<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit">
      <el-col :md="6" :sm="12">
        <el-form-item label="App名称" prop="appid">
          <!-- <SelectApp v-model="searchForm.appid"></SelectApp> -->
          <SelectCustomizeNew
            :data="apps"
            :value.sync="searchForm.appid"
          ></SelectCustomizeNew>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="行为ID" prop="action_id">
          <el-input v-model.trim="searchForm.action_id" placeholder="输入行为ID" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="行为描述" prop="ugc_label">
          <el-input
            v-model.trim="searchForm.action_name"
            placeholder="输入行为描述"
          />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="状态" prop="ugc_label">
          <el-select
            v-model="searchForm.status"
            multiple
            collapse-tags
            style="margin-left: 20px"
            placeholder="请选择"
            clearable
          >
            <el-option label="关闭" value="0"> </el-option>
            <el-option label="开启" value="1"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <TableLayout
      :column="column"
      :data="tableData.data"
      :total="tableData.total"
      :loading="tableData.loading"
      :currentPage="tableOpt.currentPage"
      :params="searchForm"
      @sizeChange="onSizeChange"
      @pageChange="onPageChange"
      :tooltipFlag="true"
    >
      <template #table-option>
        <el-button type="primary" icon="el-icon-plus" @click="openDio"
          >新增行为</el-button
        >
      </template>

      <!-- app名称 -->
      <template #appid="{ row }">
        <div>
          {{
            apps.find((item) => item.id == row.appid)
              ? apps.find((item) => item.id == row.appid).title
              : "-"
          }}
        </div>
      </template>
      <!-- app名称 -->
      <template #status="{ row }">
        <div>
          <el-popconfirm
            @confirm="onConfirm(row.id, row.action_name, row.status)"
            :title="
              row.status == 1 ? '是否确认关闭当前行为' : '是否确认开启当前行为'
            "
          >
            <el-switch
              slot="reference"
              :value="row.status == 1 ? true : false"
              inactive-color="#ff4949"
            ></el-switch>
          </el-popconfirm>
        </div>
      </template>
      <!-- 添加时间 -->
      <template #time_add="{ row }">
        <div>
          {{ moment(row.time_add * 1000).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </template>
      <!-- 操作 -->
      <template #operate="scope">
        <div>
          <el-button type="text" size="small" @click="delData(scope.row)"
            >删除</el-button
          >
          <el-button type="text" size="small" @click="changeData(scope.row)"
            >修改</el-button
          >
        </div>
      </template>
    </TableLayout>

    <!-- 新增窗口 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <span slot="title">
        {{ statusFlag ? "修改行为" : "新增行为" }}
        <el-tooltip
          class="item"
          effect="dark"
          content="只能修改行为描述，要修改行为ID与所属应用，请走删除新建"
          placement="right-end"
          v-if="statusFlag"
        >
          <i class="el-icon-info"></i>
        </el-tooltip>
      </span>
      <el-form
        :model="addActice"
        label-width="120px"
        ref="addActice"
        :rules="addFormRules"
      >
        <el-form-item label="所属应用" v-if="statusFlag">
          <el-input
            v-model="apps.find((item) => item.id == editData.appid).title"
            style="width: 300px"
            disabled
          />
        </el-form-item>
        <el-form-item label="所属应用" prop="appid" v-else>
          <!-- <SelectApp v-model="addActice.appid"></SelectApp> -->
          <SelectCustomizeNew
            :data="apps"
            :value.sync="addActice.appid"
            :styleObj="{ width: '300px' }"
          ></SelectCustomizeNew>
        </el-form-item>
        <el-form-item label="行为描述" prop="action_name">
          <el-input
            v-model.trim="addActice.action_name"
            placeholder="输入行为描述"
            style="width: 300px"
          />
        </el-form-item>

        <el-form-item label="行为ID" v-if="statusFlag">
          {{ editData.action_id }}
        </el-form-item>

        <el-form-item label="选择事件" prop="event" v-else>
          <div class="event_box">
            <div
              v-for="(item, index) in event_list"
              :key="index"
              class="event_div"
            >
              <el-select
                v-model="item.event_id"
                placeholder="请选择"
                style="width: 138px"
                @change="disabledSelect"
              >
                <el-option
                  v-for="_item in event_options"
                  :key="_item.event_id"
                  :label="_item.event_desc + `(${_item.unit})`"
                  :value="_item.event_id"
                  :disabled="disabledList.indexOf(_item.event_id) !== -1"
                >
                </el-option>
              </el-select>
              <el-input-number
                v-model="item.value"
                controls-position="right"
                :min="1"
                οninput="value=value.replace(/[^0-9]/g,'')"
                style="width: 100px"
              ></el-input-number>
              <i
                class="el-icon-delete"
                @click="delEventData(index)"
                style="margin: 0 5px; cursor: pointer"
                v-if="event_list.length > 1"
              ></i>

              <i
                @click="addEventData(index)"
                class="el-icon-circle-plus-outline"
                style="margin: 0 5px; cursor: pointer"
              ></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">{{
          statusFlag ? "修 改" : "新 增"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import store from "store2";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectApp from "@/component/select-apps";
import SelectCustomizeNew from "@/component/select-customize-new";

export default {
  name: "home",
  components: {
    FilterLayout,
    TableLayout,
    SelectApp,
    SelectCustomizeNew,
  },
  data() {
    return {
      searchForm: {
        appid: {
          appInfo: [],
        },
        action_id: "",
        action_name: "",
        status: "",
      },
      addActice: {
        appid: {
          appInfo: [],
        },
        action_name: "",
      },
      column: [
        {
          prop: "appid",
          label: "所属应用",
        },
        {
          prop: "action_id",
          label: "行为ID",
        },
        {
          prop: "action_name",
          label: "行为描述",
        },
        {
          prop: "status",
          label: "状态",
        },
        {
          prop: "time_add",
          label: "添加时间",
        },
        {
          prop: "operate",
          label: "操作",
        },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: {
        loading: false,
      },
      configList: [],
      //   应用ID
      apps: [],
      moment: moment,
      dialogVisible: false,
      //事件列表
      event_list: [
        {
          event_id: "",
          value: "1",
        },
      ],
      //   规则
      addFormRules: {
        appid: [{ required: true, message: "请选择所属应用", trigger: "blur" }],
        action_name: [
          { required: true, message: "请填写行为描述", trigger: "change" },
        ],
      },
      //   事件选项
      event_options: [],
      // 禁用选项
      disabledList: [],
      // 状态标杆
      statusFlag: false,
      // 修改的数据
      editData: {},
    };
  },
  mounted() {
    this.getReport();
    this.getRoleBtree();
    this.getEventList();
  },
  computed: {},
  methods: {
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    // 获取列表
    async getReport() {
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("key_action/list", {
        ...searchForm,
        ...tableOpt,
        appid: searchForm.appid.appInfo,
      });
      this.tableData.loading = false;

      if (err) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          loading: false,
        };
        return;
      }
      const { list, currentPage, total } = res;
      this.tableData.data = list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.getReport();
    },
    // 获取应用列表
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {});
      if (err) return;
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      this.apps = res.list[3].node;
    },
    // 获取事件列表
    async getEventList() {
      const [err, res] = await this.$http.post("event_conf/list");
      if (err) return;
      this.event_options = res.list;
    },
    // 更变状态
    async onConfirm(id, action_name, status) {
      const res = await this.$http.post("key_action/state", {
        id,
        action_name,
        status: status == "1" ? 0 : 1,
      });
      if (res[2] == 1) {
        this.$message({
          message: "更改状态成功",
          type: "success",
        });
        this.getReport();
      }
    },
    // 删除
    delData(data) {
      this.$confirm("确认删除当前行为？").then(async (_) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("key_action/del", {
          id: data.id,
        });
        if (err) return;
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.tableOpt.currentPage = 1;
        this.getReport();
      });
    },
    // 删除所选事件数据
    delEventData(index) {
      this.$confirm("确认删除当前事件？").then(() => {
        this.event_list.splice(index, 1);
        this.disabledList.splice(index, 1);
      });
    },
    // 新增所选事件数据
    addEventData(index) {
      /* this.$confirm("确认在当前事件后追加事件？").then(() => {
        }); */
      this.event_list.splice(index + 1, 0, {
        event_id: "",
        value: "1",
      });
    },
    // 重置表单
    initFrom() {
      this.searchForm = {
        appid: {
          appInfo: [],
        },
        action_id: "",
        action_name: "",
        status: "",
      };
    },
    // 打开弹窗
    openDio() {
      this.statusFlag = false;
      this.dialogVisible = true;
    },
    // 修改
    changeData(data) {
      this.statusFlag = true;
      this.editData = data;
      this.dialogVisible = true;
      this.addActice.action_name = data.action_name;
    },
    // 禁用表格项
    disabledSelect() {
      let arr = [];
      this.event_list.forEach((item) => {
        arr.push(item.event_id);
      });
      this.disabledList = arr;
    },
    // 提交新增表单
    submit() {
      if (this.addActice.appid.appInfo.length === 0) {
        this.$message.error("请填写所属应用");
        return false;
      }
      let arr = [];
      this.event_list.forEach((item) => {
        if (item.event_id == "") {
          arr.push(item);
        }
      });
      if (arr.length !== 0) {
        this.$message.error("请选择事件");
        return false;
      }
      this.$refs["addActice"].validate(async (valid) => {
        if (valid) {
          const { addActice } = this;
          const res = await this.$http.post("key_action/add", {
            appid: addActice.appid.appInfo,
            action_name: addActice.action_name,
            action_all: this.event_list,
            action_all_exec_num: 0,
          });
          if (res[2] == 1) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.event_list = [
              {
                event_id: "",
                value: "1",
              },
            ];
            this.addActice = {
              appid: {
                appInfo: [],
              },
              action_name: "",
            };
            this.addActice.action_name = "";
            this.disabledList = [];
            this.dialogVisible = false;
            this.getReport();
            this.$refs["addActice"].resetFields();
          }
        } else {
          return false;
        }
      });
    },
    // 提交修改表单
    changeForm() {
      this.$refs["addActice"].validate(async (valid) => {
        if (valid) {
          const res = await this.$http.post("key_action/state", {
            id: this.editData.id,
            action_name: this.addActice.action_name,
            status: this.editData.status,
          });
          if (res[2] == 1) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.event_list = [
              {
                event_id: "",
                value: "1",
              },
            ];
            this.addActice = {
              appid: {
                appInfo: [],
              },
              action_name: "",
            };
            this.addActice.action_name = "";
            this.dialogVisible = false;
            this.getReport();
            this.$refs["addActice"].resetFields();
          }
        } else {
          return false;
        }
      });
    },
    // 新增或者修改表格 statusFlag为真为修改
    submitForm() {
      if (this.statusFlag) {
        this.changeForm();
      } else {
        this.submit();
      }
    },
    // 关闭的回调
    closeDialog() {
      this.event_list = [
        {
          event_id: "",
          value: "1",
        },
      ];
      this.addActice = {
        appid: {
          appInfo: [],
        },
        action_name: "",
      };
      this.addActice.action_name = "";
      this.$refs["addActice"].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.event_div {
  margin: 10px 0;
}
</style>
